import api from './index';

const BASE = '/event';

export const getAllEventsByDateRange = async (
    start: string,
    end: string,
    isTEFUser: boolean,
    location?: number,
    worktype?: number
) => {
    return api
        .get(`${BASE}/allByDateRange`, { params: { start, end, isTEFUser, location, worktype } })
        .then((res) => res.data);
};

export const getEvents = async ({
    location,
    worktype,
    start,
    end,
}: {
    location: number;
    worktype: number;
    start: string;
    end: string;
}) => {
    return api.get(BASE, { params: { start, end, location, worktype } }).then((res) => res.data);
};

export const postEvent = async (data: unknown) => {
    return api.post(BASE, { data });
};

export const deleteEvent = async ({ id, deleteSerie }: { id: number; deleteSerie: boolean }) => {
    await api.delete(`${BASE}/${id}`, { params: { deleteSerie } });
};

export const getEventById = async (id: number) => {
    return api.get(`${BASE}/${id}`).then((res) => res.data);
};

export const getTotalEventsForAllLocations = async () => {
    return api.get(`${BASE}/totalEventsForAllLocations`).then((res) => res.data);
};
